<template>
  <date-picker-dropdown :value="value" @input="value => $emit('input', value)">
    <template #activator="{ on, attrs }">
      <text-field
        :value="displayValue"
        readonly
        hide-details="auto"
        v-on="on"
        v-bind="{ ...$attrs, ...attrs }"
      />
    </template>
  </date-picker-dropdown>
</template>

<script>
import DatePickerDropdown from '@/components/atoms/DatePickerDropdown';
import TextField from '@/components/atoms/TextField';
import dateTimeFormatting from '@/mixins/dateTimeFormatting';

export default {
  name: 'month-field',
  mixins: [dateTimeFormatting],
  components: {
    DatePickerDropdown,
    TextField,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    displayValue() {
      return this.value ? this.formatDate(this.value) : '';
    },
  },
};
</script>
